// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1RVm5","content":"Consent_content__97lJB","footer":"Consent_footer__381gS"};